import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { checkAuthStatus } = useAuth();
  
  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('🔐 AUTH CALLBACK: Starting callback handler');
        console.log('🔐 AUTH CALLBACK: Full URL:', window.location.href);
        console.log('🔐 AUTH CALLBACK: Search params:', window.location.search);
        
        const success = searchParams.get('success');
        const error = searchParams.get('error');
        const token = searchParams.get('token');
        const refreshToken = searchParams.get('refreshToken');
        
        console.log('🔐 AUTH CALLBACK: Params extracted:', { 
          success, 
          error, 
          hasToken: !!token, 
          hasRefreshToken: !!refreshToken,
          tokenLength: token?.length,
          refreshTokenLength: refreshToken?.length
        });
        
        if (error) {
          let errorMessage = 'SSO authentication failed';
          switch (error) {
            case 'sso_failed':
              errorMessage = 'Single Sign-On authentication failed. Please try again.';
              break;
            case 'sso_unavailable':
              errorMessage = 'Single Sign-On is currently unavailable. Please contact your administrator.';
              break;
            default:
              errorMessage = 'Authentication failed. Please try again.';
          }
          
          toast.error(errorMessage);
          navigate('/login');
          return;
        }
        
        if (success === 'true') {
          console.log('🔐 AUTH CALLBACK: Success=true, processing tokens');
          
          if (token && refreshToken) {
            console.log('🔐 AUTH CALLBACK: Tokens found in URL, storing in localStorage');
            
            // Store tokens in localStorage
            localStorage.setItem('token', token);
            localStorage.setItem('refreshToken', refreshToken);
            
            console.log('🔐 AUTH CALLBACK: Tokens stored, verifying auth status');
            
            // Verify authentication status
            try {
              await checkAuthStatus();
              console.log('🔐 AUTH CALLBACK: Auth status verified successfully');
              toast.success('Successfully signed in with SSO!');
              navigate('/dashboard');
            } catch (authError) {
              console.error('🔐 AUTH CALLBACK: checkAuthStatus failed:', authError);
              toast.error('Authentication verification failed');
              navigate('/login');
            }
          } else {
            console.warn('🔐 AUTH CALLBACK: No tokens in URL, trying fallback');
            // Fallback: check if tokens are already in cookies/localStorage
            try {
              await checkAuthStatus();
              toast.success('Successfully signed in with SSO!');
              navigate('/dashboard');
            } catch (authError) {
              console.error('🔐 AUTH CALLBACK: Fallback checkAuthStatus failed:', authError);
              toast.error('No authentication tokens found');
              navigate('/login');
            }
          }
        } else {
          console.error('🔐 AUTH CALLBACK: success !== true, redirecting to login');
          toast.error('Invalid authentication response');
          navigate('/login');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Authentication failed');
        navigate('/login');
      }
    };
    
    handleCallback();
  }, [searchParams, navigate, checkAuthStatus]);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner size="large" />
        <h2 className="mt-4 text-xl font-semibold text-gray-900">
          Completing sign-in...
        </h2>
        <p className="mt-2 text-gray-600">
          Please wait while we complete your authentication.
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
